export default __webpack_public_path__ + "static/media/Dbolt.9d4a9320.jpg";